export class ThreePlPartner {
  id: string;
  name: string;
  hooks: object;

  constructor(args: any) {
    this.id = args.id;
    this.name = args.name;
    this.hooks = args.hooks;
  }
}
